import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Fragment, useContext } from "react";
import styles from "./styles.module.scss";

export function Acknowledge() {
  const { modal, setModal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "acknowledge" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.image}>
              <Icon image="bell" size={40} color="#347aeb" />
            </div>
            <div className={styles.title}>{modal.data.title}</div>
            <div className={styles.description}>{modal.data.description}</div>
            <div className={styles.footer}>
              <div className={styles.buttons}>
                <button className={styles.cancel} onClick={() => setModal("")}>
                  {modal.data.buttonLabel}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
